<template>
    <v-container
        fill-height
        class="align-start"
    >
        <div
            class="row no-gutters"
            width="100%"
        >
            <v-col>
                <v-toolbar
                    class="elevation-0 mt-n3"
                    height="relative"
                >
                    <div class="container d-flex pb-3 pt-2 align-center">
                        <v-toolbar-title
                            color="primary"
                            class="headline font-weight-bold"
                        >
                            Health Insurance
                        </v-toolbar-title>
                    </div>

                    <template v-slot:extension>
                        <div class="container d-lg-flex py-4">
                            <div>
                                <v-text-field
                                    v-model="searchText"
                                    single-line
                                    label="Search..."
                                    outline
                                    clearable
                                />
                            </div>

                            <v-spacer />

                            <v-btn
                                depressed
                                class="align-self-center noBtnCase ml-1 primary--text"
                                color="#f8f8fd"
                                @click="showModal = true"
                            >
                                Add New Beneficiary
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-toolbar>

                <register-form
                    :dialog="showModal"
                    @save="loadItems"
                    @close="showModal = false"
                />
                <payment
                    :details="details"
                    :visible="showPayment"
                    @pay="payHandler"
                    @close="showPayment = false"
                />
                <PaidModal
                    :health-insurance-enrollee="details"
                    :visible="showPaidModal"
                    @paid="loadItems"
                    @close="showPaidModal = false"
                />
                <loading-overlay :loading="loading" />

                <v-container fluid>
                    <v-data-table
                        :items="items"
                        :headers="headers"
                        :page.sync="pagination.page"
                        :items-per-page="pagination.pageSize"
                        :server-items-length="pagination.rowCount"
                    >
                        <template #item.due_date="{ item }">
                            <div v-if="!(item.lastCompletedPayment && item.lastCompletedPayment.id)">
                                <v-btn
                                    color="blue darken-1 text-capitalize"
                                    text
                                    @click="openPaymentModal(item)"
                                >
                                    Pay
                                </v-btn>
                                <v-btn
                                    v-if="item.initiatedPayment && item.initiatedPayment.id"
                                    color="indigo"
                                    dark
                                    depressed
                                    @click="openPaidModal(item)"
                                >
                                    Paid
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>

                    <!-- <v-simple-table
                        :fixed-header="true"
                    >
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th class="text-left">
                                        Name
                                    </th>
                                    <th class="text-left">
                                        Relationship
                                    </th>
                                    <th class="text-left">
                                        Company
                                    </th>
                                    <th class="text-left">
                                        Package
                                    </th>
                                    <th class="text-left">
                                        Country
                                    </th>
                                    <th class="text-left">
                                        Monthly Premium
                                    </th>
                                    <th class="text-left">
                                        Due Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="filteredData.length">
                                <tr
                                    v-for="(item, i) in filteredData"
                                    :key="item.name"
                                >
                                    <td>{{ i+1 }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.relationship }}</td>
                                    <td>{{ item.company }}</td>
                                    <td>{{ item.package ? 'Individual' : 'Family' }}</td>
                                    <td>{{ item.country }}</td>
                                    <td>${{ formatAmount(item.price/400) }}</td>
                                    <td v-if="item.due">
                                        {{ item.due }}
                                    </td>
                                    <td v-else>
                                        <v-btn
                                            color="blue darken-1 text-capitalize"
                                            text
                                            @click="openPaymentModal({ ...item, no: i })"
                                        >
                                            Due Now
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td
                                        colspan="9"
                                        class="text-center py-5"
                                    >
                                        No match of "{{ searchText }}" found
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table> -->
                </v-container>
            </v-col>
        </div>
    </v-container>
</template>

<script>
    import { healthData } from '../../mixins/health';
    import RegisterForm from './components/register-form.vue';
    import payment from './components/payment.vue';
    import PaidModal from './components/PaidModal.vue';

    export default {
        components: { 'register-form': RegisterForm, payment, PaidModal },
        data: () => ({
            healthData,
            headers: [
                {
                    text: '#',
                    value: '',
                },
                {
                    text: 'Name',
                    value: 'full_name',
                },
                {
                    text: 'Relationship',
                    value: 'relationship',
                },
                {
                    text: 'Company',
                    value: 'healthInsurancePlan.healthInsuranceProvider.name',
                },
                {
                    text: 'Plan',
                    value: 'healthInsurancePlan.name',
                },
                {
                    text: 'Plan type',
                    value: 'healthInsurancePlan.type',
                },
                {
                    text: 'Country',
                    value: 'country.country',
                },
                // {
                //     text: 'Monthly Premium',
                //     value: 'monthly_premium',
                // },
                {
                    text: 'Due Date',
                    value: 'due_date',
                },
            ],
            items: [],
            pagination: {
                page: 1,
                pageSize: 10,
            },
            searchText: '',
            showPayment: false,
            showPaidModal: false,
            details: {},
            loading: false,
            showModal: false,
        }),
        // computed: {
        //     filteredData() {
        //         const text = this.searchText.toLowerCase();
        //         return this.healthData.filter((key) => key.name.toLowerCase().includes(text)
        //             || key.relationship.toLowerCase().includes(text)
        //             || key.country.toLowerCase().includes(text)
        //             || (key.package ? 'Individual' : 'Family').toLowerCase().includes(text)
        //             || key.company.toLowerCase().includes(text));
        //     },
        // },
        watch: {
            'pagination.page': {
                immediate: true,
                handler() {
                    this.loadItems();
                },
            },
        },
        methods: {
            async loadItems() {
                try {
                    // TODO: add server-side search
                    const {
                        pagination: {
                            page,
                            pageSize,
                        },
                    } = this;

                    const {
                        data: {
                            models,
                            pagination,
                        },
                    } = await Vue.backendApi()
                        .healthInsuranceEnrollees()
                        .getAll({
                            page,
                            pageSize,
                        });

                    this.items = models;
                    this.pagination = pagination;
                } catch (err) {
                    this.$swal({
                        type: 'error',
                        title: 'Error',
                        text: err,
                    });
                    throw err;
                }
            },
            async payHandler(item) {
                this.openPaidModal(item);
                this.loadItems();
            },
            openPaymentModal(item) {
                this.$set(this, 'details', item);
                this.showPayment = true;
            },
            openPaidModal(item) {
                this.$set(this, 'details', item);
                this.showPayment = false;
                this.showPaidModal = true;
            },
        },
    };
</script>

<style scoped>
@media screen and (max-width: 768px) {
    .v-toolbar__extension {
        height: 100px !important;
    }
}
</style>
